import { render, staticRenderFns } from "./newOrder.vue?vue&type=template&id=8e4a37c4&"
import script from "./newOrder.vue?vue&type=script&lang=js&"
export * from "./newOrder.vue?vue&type=script&lang=js&"
import style0 from "./newOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports